import React from "react";
//#region types
import { AccountingFormTypes } from "models/formTypes";
import { TranslationKeys } from "translations";
import { WintSuperkollAPIModelCustomFilters } from "wint-api-client/dist/types";
//#endregion
//#region components
import { PageLayouts, ReloadEvent } from "components/common";
import ReconciliationReport from "./reconciliationReport";
import useReconciliationReportFilterDefinition from "./hooks/useReportFilterDefinition";
import ReconciliationReportActions from "./reportActions";
import { useFinancialReportService } from "serviceHooks";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

const ReconciliationReportView: React.FC = () => {
  const financialReportService = useFinancialReportService();
  const {
    filterFormFields,
    apiToReportReconciliationFilterFormatter,
    currentReconciliationId,
    currentReconciliation,
    filterValues,
    filterQueryStateHandler,
  } = useReconciliationReportFilterDefinition();

  return (
    <ReloadEvent
      render={(reloadKey, reload) => (
        <PageLayouts.DashboardLayout<AccountingFormTypes.ReconciliationReportFilter>
          key={"reconciliationReport"}
          entityKey={0}
          title={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Accounting.Reconciliation)}
          topRightButtons={<ReconciliationReportActions />}
          filterFields={filterFormFields}
          apiToReportFilterFormatter={apiToReportReconciliationFilterFormatter}
          reportToAPIFilterFormatter={financialReportService.reconciliationReportToAPIFilter}
          filterQueryStateHandler={filterQueryStateHandler}
          filterCategory={WintSuperkollAPIModelCustomFilters.FilterCategory.Reconciliation}
          initialFilter={{
            reconciliationId: currentReconciliationId,
            reconciliation: currentReconciliation,
          }}
        >
          <ReconciliationReport
            reloadKey={reloadKey}
            reload={reload}
            initialFilterReconciliationId={currentReconciliationId}
            initialReconciliation={currentReconciliation}
            filterValues={filterValues}
          />
        </PageLayouts.DashboardLayout>
      )}
    />
  );
};

export default ReconciliationReportView;
